import React from "react";

/**
 * Paste in your SVG logo and return it from this component.
 * Make sure you have a height set for your logo.
 * It is recommended to keep the height within 25-35px.
 * Logo comes with a property value called `fill`. `fill` is useful
 * when you want to change your logo depending on the theme you are on.
 */
export default function Logo({ fill }) {
  return (
    <svg width="180" height="50" viewBox="0 0 89.25 25.36" >
      <defs>
        <linearGradient
          id="c"
          x1={417.12}
          y1={-544.42}
          x2={419.39}
          y2={-544.42}
          gradientTransform="scale(-1 1) rotate(-70.8 601.46 37.713)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#9d8fb5" />
          <stop offset={1} stopColor="#9dcaea" />
        </linearGradient>
        <linearGradient
          id="d"
          x1={417}
          y1={-544.42}
          x2={419.51}
          y2={-544.42}
          gradientTransform="scale(-1 1) rotate(-70.8 601.46 37.713)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#5666b8" />
          <stop offset={1} stopColor="#8d95c9" />
        </linearGradient>
        <linearGradient
          id="a"
          x1={430.97}
          y1={-548.94}
          x2={422.48}
          y2={-559.05}
          gradientTransform="scale(-1 1) rotate(-70.8 601.46 37.713)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#d4e1e4" />
          <stop offset={0.29} stopColor="#e6cfc6" />
          <stop offset={1} stopColor="#e84a4e" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={409.72}
          y1={-563.55}
          x2={417.31}
          y2={-554.49}
          xlinkHref="#a"
        />
        <linearGradient
          id="f"
          x1={421.06}
          y1={-542.76}
          x2={418.72}
          y2={-555.98}
          xlinkHref="#a"
        />
        <linearGradient
          id="g"
          x1={419.47}
          y1={-556.2}
          x2={419.47}
          y2={-570.31}
          gradientTransform="scale(-1 1) rotate(-70.8 601.46 37.713)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#e84a4e" />
          <stop offset={0.71} stopColor="#e6cfc6" />
          <stop offset={1} stopColor="#d4e1e4" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={415.77}
          y1={-567.43}
          x2={422.74}
          y2={-569.97}
          gradientTransform="scale(-1 1) rotate(-70.8 601.46 37.713)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#eb8b8c" />
          <stop offset={0.71} stopColor="#f2d7d5" />
          <stop offset={1} stopColor="#e2edf0" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={432.7}
          y1={-565.32}
          x2={418.28}
          y2={-557}
          gradientTransform="scale(-1 1) rotate(-70.8 601.46 37.713)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#e4e0c4" />
          <stop offset={0.29} stopColor="#e6cfc6" />
          <stop offset={1} stopColor="#e84a62" />
        </linearGradient>
        <linearGradient
          id="j"
          x1={419.85}
          y1={-562.35}
          x2={433.25}
          y2={-559.99}
          gradientTransform="scale(-1 1) rotate(-70.8 601.46 37.713)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.59} stopColor="#f24459" />
          <stop offset={1} stopColor="#eb9559" />
        </linearGradient>
        <linearGradient
          id="b"
          x1={1510.57}
          y1={-480.52}
          x2={1518.45}
          y2={-480.52}
          gradientTransform="scale(-1 1) rotate(39.7 50.507 -2354.28)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.68} stopColor="#fff7ac" />
          <stop offset={1} stopColor="#e25350" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={1514.92}
          y1={-479.96}
          x2={1519.29}
          y2={-479.96}
          xlinkHref="#b"
        />
        <linearGradient
          id="l"
          x1={1513.8}
          y1={-481.89}
          x2={1518.89}
          y2={-481.89}
          xlinkHref="#b"
        />
        <linearGradient
          id="m"
          x1={1509.33}
          y1={-478.21}
          x2={1518.61}
          y2={-478.21}
          xlinkHref="#b"
        />
        <linearGradient
          id="n"
          x1={1517.92}
          y1={-485.73}
          x2={1517.92}
          y2={-480.05}
          xlinkHref="#b"
        />
        <linearGradient
          id="o"
          x1={1519.23}
          y1={-488.13}
          x2={1519.23}
          y2={-479.9}
          xlinkHref="#b"
        />
        <linearGradient
          id="p"
          x1={1520.72}
          y1={-482.61}
          x2={1520.72}
          y2={-479.71}
          xlinkHref="#b"
        />
        <linearGradient
          id="q"
          x1={1522.04}
          y1={-486.08}
          x2={1522.04}
          y2={-479.87}
          xlinkHref="#b"
        />
        <linearGradient
          id="r"
          x1={1521.49}
          y1={-484.68}
          x2={1521.49}
          y2={-479.58}
          xlinkHref="#b"
        />
        <linearGradient
          id="s"
          x1={1517.57}
          y1={-483.64}
          x2={1517.57}
          y2={-480.17}
          xlinkHref="#b"
        />
        <linearGradient
          id="t"
          x1={1513.28}
          y1={-477.1}
          x2={1519.27}
          y2={-477.1}
          xlinkHref="#b"
        />
      </defs>
      <path
        d="M39.53 4.25h3.34c-.1 1.36-.18 3-.22 4.93a17.08 17.08 0 01-3.54.45 7.46 7.46 0 01-2.08-.28 4.46 4.46 0 01-1.68-.84 3.56 3.56 0 01-1-1.47 5.3 5.3 0 01-.37-1.93 5.36 5.36 0 01.43-2.15 4.65 4.65 0 011.22-1.69 4.83 4.83 0 011.77-1 7.52 7.52 0 012.18-.29 13.52 13.52 0 012.93.35c0 .34 0 .71.07 1.1A11.71 11.71 0 0040.92 1a7.53 7.53 0 00-1.28-.12 5.41 5.41 0 00-1.76.28 3.55 3.55 0 00-2.33 2.26 5.09 5.09 0 00-.27 1.75 4.63 4.63 0 00.25 1.5 2.73 2.73 0 00.75 1.15 3.66 3.66 0 001.2.69 5.34 5.34 0 001.58.23 10 10 0 001.11-.08 9 9 0 001.3-.29l.14-3.24h-2.12c.03-.3.04-.62.04-.88zM44.96 3.65c0-.2.09-.49.13-.88a11.93 11.93 0 011.43-.26 9.57 9.57 0 011.18-.07 5.28 5.28 0 011.15.07 2.41 2.41 0 01.89.36 1.18 1.18 0 01.47.59 2 2 0 01.12.7c0 .31 0 .84-.07 1.58s-.09 1.43-.11 2.06 0 1.19 0 1.68h-1.22l.14-1.87.11-2.21a3.52 3.52 0 01-.36.26 1.71 1.71 0 01-.27.14 2.52 2.52 0 01-.33.13l-.71.2c-.35.09-.6.17-.74.22a4.13 4.13 0 00-.75.3 2.36 2.36 0 00-.46.33 1 1 0 00-.26.35 1.21 1.21 0 00-.08.46 1 1 0 00.21.64 1.15 1.15 0 00.56.38 2.6 2.6 0 00.79.11h.6a5.63 5.63 0 00.84-.21c-.06.18-.13.45-.22.82a6.59 6.59 0 01-.81.11h-.59a3.85 3.85 0 01-1.47-.22 1.57 1.57 0 01-.78-.67 1.81 1.81 0 01-.26-1 1.75 1.75 0 01.09-.57 1.63 1.63 0 01.25-.47 1.85 1.85 0 01.45-.42 2.84 2.84 0 01.61-.35c.21-.09.46-.18.74-.27s.73-.21 1.36-.36c.2-.05.37-.09.51-.14l.38-.14a1.47 1.47 0 00.28-.16 1 1 0 00.23-.23.91.91 0 00.15-.27.86.86 0 000-.27.87.87 0 00-.21-.59 1.25 1.25 0 00-.57-.33 3.37 3.37 0 00-.83-.1 5.92 5.92 0 00-.92.08 4.62 4.62 0 00-.8.17 8.66 8.66 0 00-.85.32zM51.97 9.51c.09-1.41.18-3.07.27-5 .06-1.4.1-2.85.13-4.34h1.24l-.21 4-.12 4.05v1.26h-.6zM55.53 11.51a11.56 11.56 0 001.51.37 7.86 7.86 0 001.11.1 3.5 3.5 0 001.05-.16 2.07 2.07 0 00.69-.37 1.4 1.4 0 00.37-.48 3.75 3.75 0 00.25-1c0-.32.07-1 .09-1.93a4.55 4.55 0 01-.32.47 2.54 2.54 0 01-.36.4 3.07 3.07 0 01-.53.36 3.55 3.55 0 01-.7.25 3.62 3.62 0 01-.82.09 4 4 0 01-1.16-.17 2.65 2.65 0 01-1-.57 2.45 2.45 0 01-.65-1 3.72 3.72 0 01-.22-1.29 4.69 4.69 0 01.44-1.76 3.57 3.57 0 011-1.4 3.7 3.7 0 011.44-.79 6.15 6.15 0 011.76-.23 15 15 0 012.62.28l-.16.83-.2 3.83V10.15a4.12 4.12 0 01-.12.79 2.55 2.55 0 01-.34.57 1.75 1.75 0 01-.31.42 2.07 2.07 0 01-.41.36 2.27 2.27 0 01-.52.25 4.16 4.16 0 01-.79.2 5.82 5.82 0 01-.93.07c-.45 0-.88 0-1.31-.06a13.62 13.62 0 01-1.41-.24v-.38c-.03-.13-.04-.33-.07-.62zm5.26-8.1a7.48 7.48 0 00-1.43-.15 4.83 4.83 0 00-1.24.16 2.73 2.73 0 00-1.05.58 2.77 2.77 0 00-.74 1.08 3.59 3.59 0 00-.26 1.37 3 3 0 00.21 1.21 1.67 1.67 0 00.75.82 2.27 2.27 0 001.14.28 2.4 2.4 0 001-.19 2.1 2.1 0 00.77-.6 3 3 0 00.52-1 5.18 5.18 0 00.2-1.13c.05-.33.09-1.19.13-2.43zM63.98 3.65c0-.2.09-.49.13-.88a11.93 11.93 0 011.43-.26 9.45 9.45 0 011.18-.07 5.28 5.28 0 011.15.07 2.41 2.41 0 01.89.36 1.24 1.24 0 01.52.64 2 2 0 01.12.7c0 .31 0 .84-.07 1.58s-.09 1.43-.11 2.06 0 1.19 0 1.68H68l.14-1.87.1-2.21a3.52 3.52 0 01-.36.26 1.59 1.59 0 01-.26.14l-.34.13-.7.2c-.35.09-.6.17-.74.22a4.13 4.13 0 00-.75.3 2.09 2.09 0 00-.46.33 1 1 0 00-.26.35 1.22 1.22 0 00-.09.46 1 1 0 00.22.64 1.17 1.17 0 00.55.38 2.66 2.66 0 00.8.11h.6a5.63 5.63 0 00.84-.21 7.81 7.81 0 00-.22.82 6.59 6.59 0 01-.81.11h-.6a3.83 3.83 0 01-1.46-.22 1.64 1.64 0 01-.79-.67 1.9 1.9 0 01-.25-1 1.75 1.75 0 01.09-.57 1.63 1.63 0 01.25-.47 1.85 1.85 0 01.45-.42 3 3 0 01.6-.35c.22-.09.46-.18.74-.27s.74-.21 1.37-.36c.2-.05.37-.09.51-.14l.37-.14a1.57 1.57 0 00.29-.16 1.25 1.25 0 00.23-.23.91.91 0 00.15-.27.86.86 0 000-.27.87.87 0 00-.26-.64 1.25 1.25 0 00-.57-.33 3.45 3.45 0 00-.84-.1 5.9 5.9 0 00-.91.08 4.62 4.62 0 00-.8.17 8.66 8.66 0 00-.85.32zM70.97 9.51l.07-1c0-.21 0-.54.06-1l.18-4.18v-.78h1.15l-.06 1.27a7.2 7.2 0 01.42-.6 2.13 2.13 0 01.5-.42 2.47 2.47 0 01.7-.3 3.12 3.12 0 01.82-.1 2.86 2.86 0 01.57.11 2.41 2.41 0 01.53.2 1.56 1.56 0 01.41.28 1.27 1.27 0 01.28.34 2.57 2.57 0 01.22.53 2.53 2.53 0 011-1.1 3.06 3.06 0 011.46-.36 3 3 0 011 .15 1.86 1.86 0 01.74.45 1.52 1.52 0 01.36.62 2.31 2.31 0 01.1.64v1c0 .46-.07 1.1-.11 2s-.06 1.64-.07 2.24h-1.22c0-.62.1-1.29.13-2l.09-1.7V4.74a1.73 1.73 0 00-.09-.62 1 1 0 00-.26-.4 1.13 1.13 0 00-.45-.27 1.85 1.85 0 00-.6-.09 2 2 0 00-.51.06 1.57 1.57 0 00-.42.18 2.15 2.15 0 00-.41.32 2 2 0 00-.3.42 2.12 2.12 0 00-.21.57 5.23 5.23 0 00-.14 1c0 .42-.06 1-.08 1.67V9.5h-1.22c0-.57.08-1.15.11-1.74l.08-1.66V4.8a2.58 2.58 0 00-.06-.6 1.17 1.17 0 00-.26-.44 1.39 1.39 0 00-.45-.31 1.63 1.63 0 00-.59-.1 1.75 1.75 0 00-.65.12 1.69 1.69 0 00-.57.35 2 2 0 00-.44.57 3.14 3.14 0 00-.27.89 15.43 15.43 0 00-.23 1.89c0 .92-.06 1.68-.06 2.31h-.6zM88.66 8.39c-.06.25-.11.57-.17 1a9.21 9.21 0 01-1.13.22 7.73 7.73 0 01-1 .06 5.26 5.26 0 01-1.54-.21 2.54 2.54 0 01-1.16-.71 2.93 2.93 0 01-.7-1.17 4.48 4.48 0 01-.21-1.38 4.57 4.57 0 01.39-1.89 3 3 0 011.17-1.37 3.55 3.55 0 012-.5 3.85 3.85 0 011.19.18 2.29 2.29 0 011 .55 2.5 2.5 0 01.58.91 3.27 3.27 0 01.2 1.15 2.42 2.42 0 010 .47H84v.58a2.91 2.91 0 00.3 1.32 2 2 0 00.89.92 2.8 2.8 0 001.35.31 6.83 6.83 0 002.12-.44zm-4.61-3.25h4.08a4.7 4.7 0 00-.06-.63 1.78 1.78 0 00-.18-.5 1.24 1.24 0 00-.35-.5 1.51 1.51 0 00-.53-.29 2.11 2.11 0 00-.68-.1 2.6 2.6 0 00-.74.11 2.1 2.1 0 00-.62.3 2.18 2.18 0 00-.46.45 2.52 2.52 0 00-.23.53 5.1 5.1 0 00-.23.63z"
        fill="#ff5f5f"
      />
      <path
        d="M34.11 23.88l.07-1.07v-.8l.17-3.5V17.1v-1.24h4.94c0 .36-.05.64-.05.82-.49 0-1.19-.05-2.1-.05h-1.72l-.09 2.76h3.44v.8h-3.45c-.04 1.48-.04 2.69-.04 3.69h-1.17zM40.74 18.89c0-.18.08-.43.12-.77a9 9 0 011.22-.24 7 7 0 011-.07 5.21 5.21 0 011 .09 2 2 0 01.76.32 1 1 0 01.4.5 1.64 1.64 0 01.1.6c0 .27 0 .72-.06 1.36s-.07 1.22-.09 1.76 0 1 0 1.44h-1.08l.12-1.6.05-1.89-.31.22-.23.12a1.83 1.83 0 01-.28.1l-.61.18-.63.18a4.89 4.89 0 00-.64.26 1.78 1.78 0 00-.39.28 1.18 1.18 0 00-.23.31 1 1 0 00-.07.39.87.87 0 00.18.55 1 1 0 00.48.33 2.24 2.24 0 00.68.09 3.08 3.08 0 00.51 0 4.43 4.43 0 00.72-.17q-.07.22-.18.69c-.29.06-.52.09-.7.11h-.51a3.42 3.42 0 01-1.25-.19 1.43 1.43 0 01-.68-.57 1.65 1.65 0 01-.22-.84 1.51 1.51 0 01.08-.48 1.44 1.44 0 01.28-.44 1.73 1.73 0 01.39-.36 2.7 2.7 0 01.52-.3c.18-.08.39-.15.63-.23s.63-.18 1.17-.31l.44-.12.32-.12a1 1 0 00.44-.33.89.89 0 00.09-.23.67.67 0 000-.24.69.69 0 00-.19-.49 1 1 0 00-.49-.28 2.45 2.45 0 00-.71-.09 5.32 5.32 0 00-.78.06 6.17 6.17 0 00-.69.15c-.14.07-.39.15-.68.27zM46.71 23.88c.19-2.45.28-4.43.29-5.94h1l-.08 1.17c.1-.16.18-.29.24-.37a1.78 1.78 0 01.23-.28 1.62 1.62 0 01.35-.27 1.86 1.86 0 01.47-.22 5.23 5.23 0 01.54-.12 3.52 3.52 0 01.56 0 3.91 3.91 0 011 .12 1.82 1.82 0 01.77.4 1.46 1.46 0 01.41.63 2.88 2.88 0 01.1.74V20.6l-.12 2.46v.86h-1c0-.47.07-.93.09-1.37l.07-1.36v-1.06a1.65 1.65 0 00-.18-.83 1.1 1.1 0 00-.56-.47 2.21 2.21 0 00-.87-.17 2.14 2.14 0 00-1.17.32 2.09 2.09 0 00-.69.85 4.29 4.29 0 00-.24 1.16c-.06.62-.1 1.59-.12 2.93h-1.09zM53.71 23.77v-.43a3.43 3.43 0 000-.45 4.28 4.28 0 001.67.39 1.89 1.89 0 00.67-.1.79.79 0 00.41-.32.71.71 0 00.14-.43.67.67 0 000-.24.86.86 0 00-.11-.24 1.64 1.64 0 00-.23-.25l-.62-.52-.71-.59a3.45 3.45 0 01-.42-.44 1.6 1.6 0 01-.25-.46 1.21 1.21 0 01-.08-.46 1.23 1.23 0 01.1-.72 1.43 1.43 0 01.69-.53 3 3 0 011.05-.17 7.41 7.41 0 011.48.16c0 .3 0 .58.06.83a3.39 3.39 0 00-1.28-.29 2 2 0 00-.65.1.84.84 0 00-.43.27.65.65 0 00-.14.4.86.86 0 000 .27 1.07 1.07 0 00.17.27 2 2 0 00.29.3l.67.55a9 9 0 01.7.6 3 3 0 01.32.4 1.5 1.5 0 01.2.4 1.52 1.52 0 01.06.42 1.34 1.34 0 01-.24.76 1.65 1.65 0 01-.73.54 2.85 2.85 0 01-1.08.2 4.59 4.59 0 01-.59 0c-.22 0-.42 0-.58-.07z"
        fill="#4d4d4d"
      />
      <path
        d="M12.05 23.52a22.51 22.51 0 00-8.16 2.82c-.52-2 3.16-4.11 4.84-3.64s3.32.82 3.32.82z"
        transform="translate(-3.72 -2.49)"
        fill="url(#c)"
      />
      <path
        d="M12.13 23.43a.18.18 0 010 .09.14.14 0 01-.1.12A22.38 22.38 0 004 26.44a.14.14 0 01-.11 0 .18.18 0 01-.07-.08 2.36 2.36 0 01.86-2.22C5.8 23 7.69 22.29 8.76 22.59c1.65.46 3.3.81 3.31.81zM4 26.15a22.41 22.41 0 017.47-2.64c-.62-.15-1.68-.4-2.74-.69s-2.81.42-3.9 1.5A2.26 2.26 0 004 26.15z"
        transform="translate(-3.72 -2.49)"
        fill="url(#d)"
      />
      <path
        d="M8 12.55a14.29 14.29 0 011.5-6.63c1.92 1.56 5.56 1.93 6.63 4.49s1.5 8.07 2.22 9.1c-.92-.05-3.3-2.16-4.58-2-1.88.21-5.52-2.8-5.77-4.96z"
        transform="translate(-3.72 -2.49)"
        fill="url(#a)"
      />
      <path
        d="M11.67 6.62a4.07 4.07 0 01.85 1.25 30.15 30.15 0 011.27 5.3 14.9 14.9 0 00.94 3.78.1.1 0 010 .12.11.11 0 01-.11.06 5.26 5.26 0 01-1.84-.87 5.81 5.81 0 00-2.73-1.14c-2 .24-5.65-2.88-5.92-5a14.26 14.26 0 011.56-6.76.08.08 0 01.08 0 .1.1 0 01.09 0 11.53 11.53 0 002.59 1.41 10.46 10.46 0 013.22 1.85zm2.74 10.23a19.82 19.82 0 01-.85-3.63 30.37 30.37 0 00-1.28-5.26c-.66-1.56-2.33-2.3-3.95-3A11.62 11.62 0 015.82 3.6a14.35 14.35 0 00-1.45 6.44c.26 2 3.8 5.07 5.66 4.85.78-.09 1.89.58 2.88 1.17a8.92 8.92 0 001.5.79z"
        fill="#f24459"
      />
      <path
        d="M18.27 20.45a8 8 0 00-1.14 1.86c-.65 1.31-.58 2.34.07 2.23a4.79 4.79 0 001.29-.45s-1.23.18-.13 1.26 2.33 3 5.33 2.17 3.41-1.72 3.41-1.72.78 1 1.26.1.92-3.74.05-4.19-2.7-2.15-3.76-2a25.81 25.81 0 01-4.54.06 3.4 3.4 0 00-1.84.68z"
        transform="translate(-3.72 -2.49)"
        fill="url(#e)"
      />
      <path
        d="M24.92 19.24a1.26 1.26 0 01.27.49 6.6 6.6 0 01-.44 3.78.71.71 0 01-.56.43 1.09 1.09 0 01-.79-.4c-.25.29-1.05 1-3.4 1.64-2.67.75-4-.63-5-1.73-.15-.17-.3-.32-.44-.46-.36-.35-.53-.67-.49-.93a3.39 3.39 0 01-.57.14.51.51 0 01-.51-.18c-.28-.38-.16-1.25.31-2.22a6.93 6.93 0 01.82-1.42c.09-.11.19-.25.33-.45a3.47 3.47 0 011.92-.69 26.5 26.5 0 004.52-.05c.78-.13 1.92.69 2.84 1.34a8.54 8.54 0 001 .65 1.09 1.09 0 01.19.06zm-1.34 4.11a.88.88 0 00.59.31.48.48 0 00.37-.3 6.27 6.27 0 00.42-3.56.73.73 0 00-.32-.47 9.39 9.39 0 01-1-.68c-.88-.62-2-1.41-2.67-1.3a26.19 26.19 0 01-4.58.05 3.34 3.34 0 00-1.74.64c-.13.2-.23.33-.32.45a6.18 6.18 0 00-.8 1.38c-.49 1-.51 1.72-.33 2a.27.27 0 00.28.09 4 4 0 00.8-.25 1.16 1.16 0 01.51-.22.12.12 0 01.07.22 3.51 3.51 0 01-.45.2.24.24 0 00-.06.11c-.06.17.09.44.41.76.15.14.3.3.45.47 1 1.06 2.24 2.37 4.76 1.67 2.83-.81 3.31-1.65 3.31-1.66a.11.11 0 01.09-.06.12.12 0 01.11 0 .47.47 0 00.1.15z"
        fill="#f24459"
      />
      <path
        d="M18.31 20.43c-.77-.1-2.5.5-2.25.78s1.82.1 1.45 1.69-2.2 3.14-3.46 2.66A3.46 3.46 0 0112.27 24a6.09 6.09 0 01-6.86-3.87c-.5-1.47.38-1.33.38-1.33s-1.52-.92-1.35-1.48 3.2-.56 3.93-1.31 4.51-.42 6.17.81 2.15 3.08 2.92 2.72.89 0 .89 0z"
        transform="translate(-3.72 -2.49)"
        fill="url(#f)"
      />
      <path
        d="M14.68 16.88a.63.63 0 01.07.1v.93a.14.14 0 01-.05.08.08.08 0 01-.09 0 3.76 3.76 0 00-2.13.59.87.87 0 00.34.12c.53.15 1.42.39 1.13 1.67a4.1 4.1 0 01-2 2.53 2 2 0 01-1.63.21 3.52 3.52 0 01-1.8-1.54 6.24 6.24 0 01-6.94-3.88c-.21-.63-.22-1.06 0-1.31a.46.46 0 01.18-.13c-.47-.32-1.3-1-1.14-1.46.1-.32.69-.45 1.74-.65a5.07 5.07 0 002.22-.71c.45-.46 1.76-.5 2.83-.37a7.67 7.67 0 013.49 1.17 8.48 8.48 0 011.72 1.84c.49.67.77 1 1.08.87a1.15 1.15 0 01.87-.14.36.36 0 01.11.08zm-.17.16s-.24-.11-.72.12-.87-.26-1.37-.94a8 8 0 00-1.67-1.79c-1.7-1.26-5.37-1.49-6-.83a5.08 5.08 0 01-2.35.78c-.66.13-1.5.28-1.56.48s.7 1 1.3 1.35a.11.11 0 01.05.14.12.12 0 01-.13.08.37.37 0 00-.3.11c-.15.17-.13.55 0 1.07a5.85 5.85 0 004.12 3.7 6.49 6.49 0 002.61.08.12.12 0 01.13.07 3.28 3.28 0 001.71 1.5 1.79 1.79 0 001.44-.2 3.89 3.89 0 001.87-2.37c.24-1.06-.43-1.24-1-1.38a1 1 0 01-.48-.21.21.21 0 010-.24 3.58 3.58 0 012.25-.74z"
        fill="#f24459"
      />
      <path
        d="M18.85 20.36c1.69-.95 1.8-1.14 2.56-1s2 1.28 4.5.72 6-1.58 6.18-3.66-1.58-3.5-1.47-4.25-2.13-1.27-2.24-.59-2.06 1.9-3.1 2.07-3.8 3.87-5.15 4.15-1.28 2.56-1.28 2.56z"
        transform="translate(-3.72 -2.49)"
        fill="url(#g)"
      />
      <path
        d="M26.82 9.18a.63.63 0 01.2.5 2.24 2.24 0 00.47 1.09 5.09 5.09 0 011 3.16c-.2 2.16-3.67 3.18-6.26 3.76a5.59 5.59 0 01-3.85-.46 3.42 3.42 0 00-.69-.26c-.59-.09-.74 0-1.71.56l-.78.45a.11.11 0 01-.11 0 .11.11 0 01-.06-.1c0-.1-.07-2.39 1.36-2.69.68-.14 1.8-1.26 2.8-2.24a7.4 7.4 0 012.36-1.92c1.06-.17 2.91-1.39 3-2 .06-.33.47-.48 1.09-.39a2.24 2.24 0 011.18.54zm-11.54 8.49c.23-.13.43-.24.6-.35 1-.55 1.2-.69 1.86-.58a3.05 3.05 0 01.76.27 5.32 5.32 0 003.7.45c5.87-1.32 6-3 6.08-3.55a4.84 4.84 0 00-1-3 2.33 2.33 0 01-.51-1.24c.05-.33-.59-.66-1.18-.75s-.79 0-.82.2c-.12.77-2.2 2-3.2 2.17a7.8 7.8 0 00-2.24 1.84c-1.06 1.06-2.16 2.15-2.91 2.31-1 .2-1.14 1.68-1.14 2.23z"
        fill="#f24459"
      />
      <path
        d="M30.62 12.16c-.11.75 1.66 2.17 1.47 4.25a3.24 3.24 0 01-2 2.29c2-2.29.7-4-.76-5a3.93 3.93 0 01-.95-2.14c.11-.67 2.34-.16 2.24.6z"
        transform="translate(-3.72 -2.49)"
        fill="url(#h)"
      />
      <path
        d="M26.82 9.18a.63.63 0 01.2.5 2.24 2.24 0 00.47 1.09 5.09 5.09 0 011 3.16c-.08.91-.78 1.71-2.06 2.38a.12.12 0 01-.15 0 .12.12 0 010-.15 3.23 3.23 0 001-2.48 3.68 3.68 0 00-1.71-2.34 3.85 3.85 0 01-1-2.25c0-.33.47-.48 1.09-.39a2.24 2.24 0 011.16.48zm0 6.62a2.68 2.68 0 001.46-1.89 4.84 4.84 0 00-1-3 2.33 2.33 0 01-.51-1.24c.05-.33-.59-.66-1.18-.75s-.79 0-.82.2a3.87 3.87 0 00.89 2 3.77 3.77 0 011.82 2.51 3.08 3.08 0 01-.64 2.17z"
        fill="#f24459"
      />
      <path
        d="M18.35 19.51c-.72-1.58-3.75-8.76-2.73-10s2.43-3 2.58-4.18a2.94 2.94 0 014.1-1.87c2 1 3.4 2.94 2.76 4.81 1.05.91 2.18 0 2.2 1.06S26.87 14 24.8 14.9s-6.45 4.61-6.45 4.61z"
        transform="translate(-3.72 -2.49)"
        fill="url(#i)"
      />
      <path
        d="M24 4.55a4.42 4.42 0 01.73.91 3.25 3.25 0 01.47 2.74 2 2 0 001.28.38c.46 0 .89 0 .9.72 0 1.19-.43 4.8-2.53 5.71s-6.38 4.55-6.42 4.59a.12.12 0 01-.1 0 .1.1 0 01-.08-.07c-.32-.67-1.28-2.91-2-5.13-.92-2.75-1.15-4.44-.69-5 .9-1.11 2.4-3 2.56-4.12a2.93 2.93 0 011.58-1.94 2.8 2.8 0 012.68 0A6.65 6.65 0 0124 4.55zm1 3.77a.11.11 0 010-.12c.47-1.38-.18-3.36-2.71-4.66a2.59 2.59 0 00-2.46 0 2.67 2.67 0 00-1.46 1.76c-.16 1.22-1.69 3.11-2.6 4.24s1.44 7 2.68 9.75c.73-.61 4.47-3.7 6.36-4.52a4.09 4.09 0 001.94-2.65 10.05 10.05 0 00.44-2.84c0-.46-.21-.47-.66-.48a2.19 2.19 0 01-1.5-.5z"
        transform="translate(-3.72 -2.49)"
        fill="url(#j)"
      />
      <path
        d="M12.5 17.21a1 1 0 01.16-.74 1.7 1.7 0 011.17-.71 1.67 1.67 0 01.74 0l.18.05a1.14 1.14 0 01.42.23 1 1 0 01.39.63 1.24 1.24 0 01.06.53c0 .28-.21.91-1.46 1.06-1.59.25-1.64-.91-1.66-1.05z"
        fill="#e25350"
      />
      <path
        d="M15.36 16.07a1.13 1.13 0 01.32.61v.12a1 1 0 010 .45c0 .19-.16 1-1.57 1.15-1 .11-1.68-.29-1.79-1.15a1.21 1.21 0 01.18-.82 1.88 1.88 0 011.25-.77 2 2 0 01.78 0l.21.06a1.53 1.53 0 01.45.25.52.52 0 01.17.1zm-2.45 1.8a1.4 1.4 0 001.23.29c1.27-.14 1.36-.81 1.36-.94a1 1 0 000-.33.4.4 0 010-.15.94.94 0 00-.35-.56 1.22 1.22 0 00-.39-.21l-.17-.05a1.78 1.78 0 00-.69 0 1.66 1.66 0 00-1.09.66 1 1 0 00-.15.66 1 1 0 00.25.63z"
        fill="#f24459"
      />
      <path
        d="M14.67 18.42s1.18 4.15 3.32 5.24v.07a.06.06 0 01-.08 0 6.78 6.78 0 01-2.52-3.08 15.82 15.82 0 01-.81-2.14.06.06 0 010-.07 NaN NaN 0 01.09-.02zM22.99 19.88a1.92 1.92 0 01.54.85.06.06 0 010 .07h-.07c-.77-2.49-7.72-2.91-7.79-2.91s-.05 0-.05-.07a.06.06 0 01.06-.05 24.57 24.57 0 013.64.52 7.71 7.71 0 013.67 1.59zM11.52 18.41a.06.06 0 010 .08 5.21 5.21 0 01-5.6 1.53.08.08 0 01-.05-.07.09.09 0 01.08-.05 5.08 5.08 0 005.48-1.49.07.07 0 01.09 0zM10.88 16.61a.06.06 0 010 .07.05.05 0 01-.08 0 5.57 5.57 0 00-3.92-.17.06.06 0 01-.07 0 .05.05 0 010-.07 5.69 5.69 0 014 .2zM21.22 6.27a8.53 8.53 0 01-.67 3.72c-.81 1.74-3.91 4.29-3.94 4.31a.06.06 0 01-.09 0 .07.07 0 010-.09s3.11-2.55 3.91-4.27a8.34 8.34 0 00.66-3.66.08.08 0 01.05-.07zM19.64 5.74c.23.69-.14 2-1.11 3.73a27.7 27.7 0 01-1.51 2.47.061.061 0 11-.1-.07s3.13-4.51 2.61-6.1a.06.06 0 010-.07.07.07 0 01.11.04zM10.02 7.9c2 2.52 3 7.08 3.07 7.12a.08.08 0 010 .07.06.06 0 01-.07 0c0-.05-1-4.58-3-7.08a.05.05 0 010-.08.06.06 0 010-.03zM11.66 14.23a.06.06 0 010 .08.05.05 0 01-.08 0 10.54 10.54 0 01-2.77-2.68.06.06 0 010-.08.05.05 0 01.08 0 10.58 10.58 0 002.73 2.65z"
        fill="#f4c3c6"
      />
      <path
        d="M22.71 11.83a.08.08 0 010 .05 10.54 10.54 0 01-4.19 7.2.06.06 0 01-.08 0 .07.07 0 010-.09 10.41 10.41 0 004.13-7.12.07.07 0 01.07 0z"
        transform="translate(-3.72 -2.49)"
        fill="url(#b)"
      />
      <path
        d="M20.25 15.69c.11 1.4-2.42 3.6-2.53 3.69a.06.06 0 01-.08 0 .08.08 0 010-.09s2.59-2.25 2.5-3.59a.05.05 0 01.05-.06.06.06 0 01.06.05z"
        transform="translate(-3.72 -2.49)"
        fill="url(#k)"
      />
      <path
        d="M18.92 12.31a7.38 7.38 0 01-.26 4.13 17.44 17.44 0 01-.89 2.35h-.07v-.07c0-.05 1.95-4.11 1.13-6.4a.06.06 0 010-.07.06.06 0 01.09.06z"
        transform="translate(-3.72 -2.49)"
        fill="url(#l)"
      />
      <path
        d="M26.05 13.94v.07a25.59 25.59 0 01-2.51 2.75c-1.93 1.82-3.59 2.72-4.93 2.7a.06.06 0 110-.12c3.12.06 7.31-5.34 7.35-5.4a.06.06 0 01.08 0z"
        transform="translate(-3.72 -2.49)"
        fill="url(#m)"
      />
      <path
        d="M15.75 12.78a.08.08 0 010 .05 7.57 7.57 0 001.49 5.92.06.06 0 01-.09.07 7.73 7.73 0 01-1.52-6 .08.08 0 01.07-.05z"
        transform="translate(-3.72 -2.49)"
        fill="url(#n)"
      />
      <path
        d="M12.86 12.05a16.09 16.09 0 002.56 5.79 5.24 5.24 0 001.43 1.37.07.07 0 010 .08.07.07 0 01-.08 0s-2.55-1.37-4-7.24a.06.06 0 010-.08z"
        transform="translate(-3.72 -2.49)"
        fill="url(#o)"
      />
      <path
        d="M16.78 19.57a.07.07 0 010 .06.08.08 0 01-.07.05A5.29 5.29 0 0114 18.26a.06.06 0 11.09-.07 5.25 5.25 0 002.64 1.37z"
        transform="translate(-3.72 -2.49)"
        fill="url(#p)"
      />
      <path
        d="M16.38 19.7a.09.09 0 010 .05l-.06.05a17 17 0 01-2.67-.59c-1.87-.57-3.07-1.33-3.56-2.24a.08.08 0 010-.08.08.08 0 01.09 0c1.13 2.1 6.08 2.76 6.13 2.77z"
        transform="translate(-3.72 -2.49)"
        fill="url(#q)"
      />
      <path
        d="M16.42 20a.08.08 0 010 .05s0 .05-.07.05a4.85 4.85 0 01-4.21-3.06.05.05 0 010-.07.06.06 0 01.08 0 4.74 4.74 0 004.11 3z"
        transform="translate(-3.72 -2.49)"
        fill="url(#r)"
      />
      <path
        d="M17.31 14.2a13.34 13.34 0 01.18 4.22s0 .06-.07.06a.08.08 0 01-.05-.07 13.35 13.35 0 00-.18-4.17.07.07 0 010-.08s.11.02.12.04z"
        transform="translate(-3.72 -2.49)"
        fill="url(#s)"
      />
      <path
        d="M24.61 18.4a.06.06 0 010 .09c-1.92 1.83-6.31 1.57-6.35 1.57a.06.06 0 010-.12c.05 0 4.39.26 6.27-1.54a.08.08 0 01.08 0z"
        transform="translate(-3.72 -2.49)"
        fill="url(#t)"
      />
      <ellipse
        cx={10.11}
        cy={16.86}
        rx={0.43}
        ry={0.35}
        transform="rotate(-21.78 1.794 25.275)"
        fill="#fff7ac"
      />
      <ellipse
        cx={15.67}
        cy={12.74}
        rx={0.35}
        ry={0.43}
        transform="rotate(-74.83 12.18 13.929)"
        fill="#fff7ac"
      />
      <ellipse
        cx={22.63}
        cy={11.69}
        rx={0.35}
        ry={0.43}
        transform="rotate(-79.61 19.281 12.682)"
        fill="#fff7ac"
      />
      <ellipse
        cx={26.12}
        cy={13.75}
        rx={0.35}
        ry={0.43}
        transform="rotate(-46.63 21.378 16.82)"
        fill="#fff7ac"
      />
      <ellipse
        cx={17.24}
        cy={13.98}
        rx={0.34}
        ry={0.31}
        transform="rotate(-21.78 8.92 22.415)"
        fill="#fff7ac"
      />
      <ellipse
        cx={18.84}
        cy={12.2}
        rx={0.39}
        ry={0.31}
        transform="rotate(-21.78 10.506 20.617)"
        fill="#fff7ac"
      />
      <ellipse
        cx={13.92}
        cy={18.11}
        rx={0.34}
        ry={0.27}
        transform="rotate(-24.87 6.403 25.309)"
        fill="#fff7ac"
      />
      <ellipse
        cx={24.69}
        cy={18.41}
        rx={0.27}
        ry={0.34}
        transform="rotate(-39.49 19.352 22.356)"
        fill="#fff7ac"
      />
      <ellipse
        cx={20.06}
        cy={15.51}
        rx={0.34}
        ry={0.27}
        transform="rotate(-24.87 12.567 22.697)"
        fill="#fff7ac"
      />
      <ellipse
        cx={12.21}
        cy={17}
        rx={0.3}
        ry={0.22}
        transform="rotate(-21.78 3.892 25.436)"
        fill="#fff7ac"
      />
      <ellipse
        cx={12.82}
        cy={12.03}
        rx={0.3}
        ry={0.22}
        transform="rotate(-21.78 4.5 20.459)"
        fill="#fff7ac"
      />
    </svg>
  );
}
